import React, {useState} from 'react';
import team from '../assets/img/Team04.jpg'
import chateau from '../assets/img/chateau.jpg'
import {Col, Container, Image, Row} from "react-bootstrap";
import './home.css'
import ReactPlayer from "react-player";

import projects from '../assets/img/icons/projects.svg'
import tech from '../assets/img/icons/technology.png'
import international from '../assets/img/icons/international.svg'
import dynamique from '../assets/img/icons/support.svg'
import social from '../assets/img/icons/social.svg'
import sympa from '../assets/img/icons/Sympa.svg'
import lieu from '../assets/img/icons/Chateau.png'
import sport from '../assets/img/icons/Sport.svg'
import parc from '../assets/img/icons/Park.svg'
import basket from '../assets/img/icons/Terrain de basket.svg'
import english from '../assets/img/icons/English.png'
import hospital from '../assets/img/icons/Hospital.svg'
import coffee from '../assets/img/icons/coffee-cup.svg'
import voucher from '../assets/img/icons/voucher.svg'


const iconsCompany = [
    {img:projects, text:"Projets variés"},
    {img:tech, text:"Technologie et matériel de pointe"},
    {img:international, text:"Projets internationaux et ambitieux"},
    {img:dynamique, text:"Equipe dynamique"},
    {img:social, text:"Activités diverses"},
]
const iconsCompanyEn = [
    {img:projects, text:"Various projects"},
    {img:tech, text:"Top material and technology"},
    {img:international, text:"International and ambitious projects"},
    {img:dynamique, text:"Dynamic team"},
    {img:social, text:"Various activities"},
]

const iconsLifestyle = [
    {img:sympa, text:"Ambiance sympa"},
    {img:lieu, text:"Lieu de travail agréable"},
    {img:sport, text:"Salle de sport"},
    {img:parc, text:"Parc"},
    {img:basket, text:"Terrain de Basket"},
]

const iconsLifestyleEn = [
    {img:sympa, text:"GOOD ATMOSPHERE"},
    {img:lieu, text:"PLEASANT WORKPLACE"},
    {img:sport, text:"SPORTS ROOM"},
    {img:parc, text:"Park"},
    {img:basket, text:"BASKETBALL COURT"},
]

const iconsPlus = [
    {img:english, text:"Cours d'anglais"},
    {img:hospital, text:"Assurance Hospitalisation"},
    {img:coffee, text: "Petits déjeuners et café"},
    {img: voucher, text: "Chèques repas"}
]

const iconsPlusEn = [
    {img:english, text:"ENGLISH COURSE"},
    {img:hospital, text:"HOSPITALIZATION INSURANCE"},
    {img:coffee, text: "Breakfast and coffee"},
    {img: voucher, text: "Meal Voucher"}
]

function Home() {
    const [en, setEn] = useState(false);
    return (
        <div>
            <Container className="cont" fluid>
                <Row>
                    <Col>
                        <div>
                            <img className="teamImg" src={team} alt="team"/>
                            {en ?
                                <div className="title-header">
                                    <h1>CG Artist<br/><p style={{color: "#fff"}}>Specializing in Industrial Visualization</p></h1>
                                </div>
                                :
                                <div className="title-header">
                                    <h1>Infographiste 3D<br/><p style={{color: "#fff"}}>Spécialisé en visualisation des produits industrielles</p></h1>
                                </div>
                            }
                        </div>
                        <button className="languageSelector" onClick={() => setEn(!en)}>{en ? "FR" : "EN"}</button>
                    </Col>
                </Row>
            </Container>
            <Container className="cont" fluid>
                <Row className="justify-content-md-center">
                    <Col className="colu" md="6">
                        <div className="hiring">
                            {en ?
                                <>
                                    <h2>Join Miysis</h2>
                                    <p>
                                    Are you looking for an exciting position in a fun, passionate, and motivated team?
                                    Do you dream of working on international projects in an exceptional work environment?
                                    Good news: Miysis is hiring!
                                    </p>
                                    <p>
                                        We are looking for a <strong>3D artist specialized in photorealistic rendering</strong>, with <strong>basic understanding of animation</strong>, to join our team dedicated to <strong>visualizing industrial, technical, and medical products.</strong>
                                    </p>
                                    <p>
                                        If you're passionate about 3D, detail-oriented, curious, and enjoy bringing complex projects to life in sectors such as <strong>industry, aerospace, defense, and pharma</strong>, this opportunity is for you.
                                    </p>
                                </>
                                :
                                <>
                                    <h2>Rejoignez Miysis</h2>
                                    <p>
                                        Vous cherchez un poste stimulant, au sein d'une équipe fun, motivée et passionnée ?
                                        Vous rêvez de travailler sur des projets internationaux dans un cadre exceptionnel ?
                                        Bonne nouvelle : Miysis recrute !
                                    </p>
                                    <p>
                                        Nous recherchons un(e) <strong>infographiste 3D spécialisé(e) dans le rendu photo-réaliste</strong>, disposant également de <strong>notions en animation</strong>, pour renforcer notre équipe dédiée à la <strong>visualisation de produits industriels, techniques et médicaux.</strong>
                                    </p>
                                    <p>
                                        Vous êtes passionné(e) par l'image et la 3D, curieux(se), rigoureux(se), et aimez donner vie à des projets complexes dans des secteurs variés tels que <strong>l'industrie, l'aéronautique, la défense, la pharma, etc.</strong> ? Alors ce poste est pour vous.
                                    </p>
                                </>
                            }
                        </div>
                    </Col>
                    <Col className="colu" md="6">
                        <div>
                            <Image src={chateau} fluid/>
                        </div>
                    </Col>
                </Row>
            </Container>
            <Container className="job" fluid>
                <Row>
                    <Col>
                        {en ?
                            <div style={{marginBottom: "0"}} className="container profile-container">
                                <h2 >Profile</h2>
                                <div className="prof-ul">
                                    <ul>
                                        <li><i className="fas fa-caret-right"></i><p>Passionate about 3D and visual storytelling</p></li>
                                        <li><i className="fas fa-caret-right"></i><p>Available soon to work on-site at our offices in <strong>Liège, Belgium</strong></p></li>
                                        <li><i className="fas fa-caret-right"></i><p>Partial remote work possible depending on your location</p></li>
                                        <li><i className="fas fa-caret-right"></i><p>Skilled in <strong>3Ds Max and V-Ray</strong> (or similar software)</p></li>
                                        <li><i className="fas fa-caret-right"></i><p>Able to create <strong>high-quality photorealistic renders</strong> of products in studio or environment settings</p></li>
                                        <li><i className="fas fa-caret-right"></i><p>Basic knowledge of <strong>3D animation</strong> for explaining product functionality</p></li>
                                        <li><i className="fas fa-caret-right"></i><p>Ideally familiar with <strong>After Effects</strong> and <strong>Photoshop</strong></p></li>
                                        <li><i className="fas fa-caret-right"></i><p>Bonus: experience with <strong>Phoenix FD</strong> and/or <strong>TyFlow</strong></p></li>
                                        <li><i className="fas fa-caret-right"></i><p>Language skills are a strong asset (English, French, Dutch, or German)</p></li>
                                        <li><i className="fas fa-caret-right"></i><p><strong>French is not required</strong></p></li>
                                    </ul>
                                </div>
                            </div>
                            :
                            <div style={{marginBottom: "0"}} className="container profile-container">
                                <h2 >Profil recherché</h2>
                                <div className="prof-ul">
                                    <ul>
                                        <li><i className="fas fa-caret-right"></i><p>Passionné(e) par la 3D et l'image de synthèse</p></li>
                                        <li><i className="fas fa-caret-right"></i><p>Disponible rapidement pour travailler à <strong>Liège (Belgique)</strong> dans nos bureaux</p></li>
                                        <li><i className="fas fa-caret-right"></i><p>Télétravail partiel possible selon la distance domicile–bureaux</p></li>
                                        <li><i className="fas fa-caret-right"></i><p>Maîtrise de <strong>3Ds Max et V-Ray</strong> (ou logiciels équivalents)</p></li>
                                        <li><i className="fas fa-caret-right"></i><p>Capacité à produire des rendus photo-réalistes de produits sur fond studio ou en environnement</p></li>
                                        <li><i className="fas fa-caret-right"></i><p>Compétences de base en <strong>animation 3D explicative</strong> (illustration de fonctionnement produit)</p></li>
                                        <li><i className="fas fa-caret-right"></i><p>Connaissances appréciées : <strong>After Effects</strong> et <strong>Photoshop</strong></p></li>
                                        <li><i className="fas fa-caret-right"></i><p>Bonus : notions en <strong>Phoenix FD</strong> et/ou <strong>TyFlow</strong></p></li>
                                        <li><i className="fas fa-caret-right"></i><p>La connaissance des langues est un atout (anglais, français, néerlandais, allemand)</p></li>
                                        <li><i className="fas fa-caret-right"></i><p><strong>Le français n'est pas obligatoire</strong></p></li>
                                    </ul>
                                </div>
                            </div>
                        }
                        {en ?
                            <div className="container profile-container">
                                <h2 style={{paddingTop:'4%', marginBottom: "3.5rem"}}>Job description</h2>
                                <div className="prof-ul">
                                    <ul>
                                        <li><i className="fas fa-caret-right"></i><p>Position: Versatile 3D Artist</p></li>
                                        <li><i className="fas fa-caret-right"></i><p>Full-time permanent contract</p></li>
                                        <li><i className="fas fa-caret-right"></i><p>Creation of 3D content from conception to client delivery</p></li>
                                        <li><i className="fas fa-caret-right"></i><p>Realistic product modeling and texturing</p></li>
                                        <li><i className="fas fa-caret-right"></i><p>Creation of realistic environments</p></li>
                                        <li><i className="fas fa-caret-right"></i><p>Production of high-end still visuals and explanatory 3D animations</p></li>
                                        <li><i className="fas fa-caret-right"></i><p>Training and onboarding will be provided at the start of your employment.</p></li>
                                    </ul>
                                </div>
                            </div>
                            :
                            <div className="container profile-container">
                                <h2 style={{paddingTop:'4%', marginBottom: "3.5rem"}}>Description du poste</h2>
                                <div className="prof-ul">
                                    <ul>
                                        <li><i className="fas fa-caret-right"></i><p>Intitulé : Infographiste 3D polyvalent(e)</p></li>
                                        <li><i className="fas fa-caret-right"></i><p>Contrat à durée indéterminée – Temps plein</p></li>
                                        <li><i className="fas fa-caret-right"></i><p>Création de contenus 3D de la conception à la livraison client</p></li>
                                        <li><i className="fas fa-caret-right"></i><p>Modélisation et texturing réaliste des produits</p></li>
                                        <li><i className="fas fa-caret-right"></i><p>Création d'environnements et de rendus fixes de haut niveau</p></li>
                                        <li><i className="fas fa-caret-right"></i><p>Réalisation d'animations 3D explicatives</p></li>
                                        <li><i className="fas fa-caret-right"></i><p>Un accompagnement et une formation sont prévus à votre arrivée</p></li>
                                    </ul>
                                </div>
                            </div>
                        }
                        {en ?
                            <div className="container profile-container">
                                <h2 style={{paddingTop: '4%'}}>How to Apply</h2>
                                <div>
                                    <p>Send your application to:<br/>
                                    <strong><a href="mailto:jobs@miysis.be">jobs@miysis.be</a></strong><br/>
                                    <strong>By 15/09/2025</strong></p>

                                    <p>A portfolio is required with your application.</p>

                                    <p>We also offer an optional test to help you demonstrate your skills.<br/>
                                    The test can be completed from home.<br/>
                                    You can download the brief and necessary files here: <strong><a href="https://miro.com/app/board/uXjVI13kqe0=/" target='_blank'>Link to Test</a></strong></p>

                                    <p>Thank you for your interest and enthusiasm. We look forward to hearing from you.<br/>
                                    The Miysis Team</p>
                                </div>
                            </div>
                            :
                            <div className="container profile-container">
                                <h2 style={{paddingTop: '4%'}}>Candidatures</h2>
                                <div>
                                    <p>Envoyez votre candidature à l'adresse suivante :<br/>
                                    <strong><a href="mailto:jobs@miysis.be">jobs@miysis.be</a></strong><br/>
                                    <strong>Avant le 15/09/2025</strong></p>

                                    <p>La présence d'un portfolio est obligatoire.</p>

                                    <p>Un test facultatif vous est proposé afin de démontrer votre savoir-faire.<br/>
                                    Ce test peut être réalisé à domicile.<br/>
                                    Vous pouvez télécharger le briefing ainsi que les fichiers nécessaires ici : <strong><a href="https://miro.com/app/board/uXjVI13kqe0=/" target='_blank'>Link to Test</a></strong></p>

                                    <p>Merci pour votre intérêt et votre enthousiasme. À très bientôt.<br/>
                                    L'équipe Miysis</p>
                                </div>
                            </div>
                        }
                    </Col>
                </Row>
            </Container>
            <Container className="video" fluid>
                <Row>
                    <Col>
                        <section style={{display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%', padding: '5% 0'}}
                                 className="section_container">
                            <div>
                                {en ?
                                    <h2 style={{color: 'white', marginBottom: '3.5rem'}}>TYPE OF PROJECTS THE CANDIDATE WILL HAVE THE OPPORTUNITY TO WORK ON</h2>
                                    :
                                    <h2 style={{color: 'white',marginBottom: '3.5rem'}}>TYPE DE PROJETS SUR LESQUELS LE/LA CANDIDAT(E) AURA L'OCCASION DE TRAVAILLER</h2>
                                }
                            </div>
                            <div className={"player-wrapper"}>
                                <ReactPlayer
                                    url="https://vimeo.com/1094743666/d3d0b2edef"
                                    controls={true}
                                    width='100%'
                                    height='100%'
                                    className='react-player'
                                />
                            </div>
                        </section>
                    </Col>
                </Row>
            </Container>
            <Container fluid>
                <Row>
                    <Col>
                        {en ?
                            <div style={{padding: '5% 0'}}>
                                <h2>Miysis offers many advantages related to the function</h2>
                                <div className="flex_container">
                                    {iconsCompanyEn.map((icon, i) =>
                                        <div className='icon-cont'>
                                            <img width="100px" src={icon.img} alt={icon.text}/>
                                            <h4>{icon.text}</h4>
                                        </div>
                                    )}
                                </div>
                                <div className="flex_container">
                                    {iconsLifestyleEn.map((icon, i) =>
                                        <div className='icon-cont'>
                                            <img width="100px" src={icon.img} alt={icon.text}/>
                                            <h4>{icon.text}</h4>
                                        </div>
                                    )}
                                </div>
                                <div className="flex_container">
                                    {iconsPlusEn.map((icon, i) =>
                                        <div className='icon-cont'>
                                            <img width="100px" src={icon.img} alt={icon.text}/>
                                            <h4>{icon.text}</h4>
                                        </div>
                                    )}
                                </div>
                            </div>
                            :
                            <div style={{padding: '5% 0'}}>
                                <h2>Miysis propose de nombreux avantages liés à la fonction</h2>
                                <div className="flex_container">
                                    {iconsCompany.map((icon, i) =>
                                        <div className='icon-cont'>
                                            <img width="100px" src={icon.img} alt={icon.text}/>
                                            <h4>{icon.text}</h4>
                                        </div>
                                    )}
                                </div>
                                <div className="flex_container">
                                    {iconsLifestyle.map((icon, i) =>
                                        <div className='icon-cont'>
                                            <img width="100px" src={icon.img} alt={icon.text}/>
                                            <h4>{icon.text}</h4>
                                        </div>
                                    )}
                                </div>
                                <div className="flex_container">
                                    {iconsPlus.map((icon, i) =>
                                        <div className='icon-cont'>
                                            <img width="100px" src={icon.img} alt={icon.text}/>
                                            <h4>{icon.text}</h4>
                                        </div>
                                    )}
                                </div>
                            </div>
                        }
                    </Col>
                </Row>
            </Container>
            <Container className="join" fluid>
                <Row>
                    <Col>
                        {en ?
                            <div className="cont-join">
                              <div style={{padding: '2% 0'}}>
                                  <h2 className={"join"} style={{color: '#fff'}}>Join us !</h2>
                                  <p style={{color: '#fff'}}><i className="fas fa-envelope"/> jobs@miysis.be</p>
                                  <p style={{color: '#fff'}}><i className="fas fa-phone"/> +32 4 240 38 40</p>
                                  <p style={{marginTop: "3%"}}><a className={"miysisbe"} href="https://www.miysis.be" target="_blank"
                                                                  rel="noopener noreferrer">www.miysis.be</a></p>
                              </div>
                            </div>
                            :
                            <div className="cont-join">
                              <div style={{padding: '2% 0'}}>
                                  <h2 className={"join"} style={{color: '#fff'}}>Join us !</h2>
                                  <p style={{color: '#fff'}}><i className="fas fa-envelope"/> jobs@miysis.be</p>
                                  <p style={{color: '#fff'}}><i className="fas fa-phone"/> +32 4 240 38 40</p>
                                  <p style={{marginTop: "3%"}}><a className={"miysisbe"} href="https://www.miysis.be" target="_blank"
                                                                  rel="noopener noreferrer">www.miysis.be</a></p>
                              </div>
                            </div>
                        }

                    </Col>
                </Row>
            </Container>
            <div className={"copyright"}>
                <p>
                    Copyright {new Date().getFullYear()} - Miysis 3D Studio
                </p>
            </div>
        </div>
    );
}

export default Home;
